export const MapPriceName = new Map()
MapPriceName.set('data', 'Quản lý dữ liệu')
MapPriceName.set('stock', 'Quản lý kho bãi')

export const MapPriceLevel = new Map()
MapPriceLevel.set('1', 'Gói căn bản')
MapPriceLevel.set('2', 'Gói nâng cao')
MapPriceLevel.set('3', 'Gói chuyên nghiệp')